module.exports = __webpack_public_path__ + "img/142706d69cdb45723db9623dc5f645e6.png";